import Close from "@/assets/icons/Close";
import Info from "@/assets/icons/Info";
import { Heading } from "@/components/ui/heading";
import { Modal, ModalBackdrop, ModalBody, ModalCloseButton, ModalContent } from "@/components/ui/modal";

import Clock from "@/assets/icons/Clock";
import AppButton from "@/components/shared/AppButton";
import { Box } from "@/components/ui/box";
import { Divider } from "@/components/ui/divider";
import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { T, useT } from "@transifex/react";
import { useRouter } from "expo-router";
import type { AlreadyPaidData } from "ipctg-inflow-types/InFlowAPIMisc";

interface SessionInProgressModalProps {
  isOpen: boolean;
  onClose: () => void;
  alreadyPaidData: AlreadyPaidData | null;
  plate: string;
}

const SessionInProgressModal: React.FC<SessionInProgressModalProps> = ({ isOpen, onClose, alreadyPaidData /* plate */ }) => {
  const t = useT();
  const router = useRouter();
  const goToHelp = () => {
    onClose();
    setTimeout(() => router.push("/help"), 300);
  };

  // const goToReceipt = () => {
  //   onClose();
  //   setTimeout(
  //     () =>
  //       router.push({
  //         params: {
  //           receiptID: alreadyPaidData.receiptID,
  //         },
  //         pathname: "/receipt",
  //       }),
  //     300,
  //   );
  // };

  const goToExtendSession = () => {
    if (alreadyPaidData?.sessionID) {
      router.push({
        pathname: "/selectrate",
        params: {
          canExtend: "true",
          sessionID: alreadyPaidData.sessionID,
        },
      });
    }
    onClose();
  };

  // <T _str="This plate already has an active session for this location. Click below to view your receipt." />
  const sessionMessage = alreadyPaidData?.canExtendSession ? (
    <T _str="This plate has an active session at this location. Click the button below to extend your session." />
  ) : (
    <T _str="This plate already has an active session for this location." />
  );

  return (
    <Modal isOpen={isOpen} size="lg">
      <ModalBackdrop />
      <ModalContent className="bg-background-100 max-w-md mx-auto rounded-[16px]">
        <ModalCloseButton onPress={onClose} className="absolute top-4 right-4 z-10" data-test-id="close-button">
          <Close height={26} fill="text-typography-800" width={26} />
        </ModalCloseButton>

        <ModalBody>
          <Box className="flex flex-col items-center">
            <Info />
            <Heading className="mt-3 text-center text-lg">
              <T _str="You already have an active session" />
            </Heading>
            <Text className="text-center text-sm text-typography-900 mt-2">{sessionMessage}</Text>
          </Box>
        </ModalBody>
        <Box className="pb-4 w-full">
          <Divider className="my-0.5 w-full bg-secondary-400" />
        </Box>
        {alreadyPaidData?.canExtendSession ? (
          <VStack className="w-full gap-2">
            {/* <AppButton className="flex-1" onPress={goToReceipt} title={t("View receipt")} variant="outline" /> */}
            <AppButton className="flex-1" onPress={goToHelp} title={t("Need help?")} variant="outline" />
            <AppButton className="flex-1" onPress={goToExtendSession} title={t("Extend Session")} icon={Clock} />
          </VStack>
        ) : (
          <HStack className="w-full gap-2">
            <AppButton className="flex-1" onPress={goToHelp} title={t("Need help?")} variant="outline" />
            {/* <AppButton className="flex-1" onPress={goToReceipt} title={t("View receipt")} /> */}
          </HStack>
        )}
      </ModalContent>
    </Modal>
  );
};

export default SessionInProgressModal;
